<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M5.78769 4.78793C7.83794 2.73768 11.1621 2.73768 13.2123 4.78793L18.4449 10.0205L17.3842 11.0812L12.1517 5.84859C10.6872 4.38413 8.31282 4.38413 6.84835 5.84859C5.38388 7.31306 5.38388 9.68743 6.84835 11.1519L13.4521 17.7557C14.3936 18.6972 15.9201 18.6972 16.8616 17.7557C17.8031 16.8142 17.8031 15.2877 16.8616 14.3462L10.4853 7.96991C10.0668 7.55138 9.3882 7.55138 8.96967 7.96991C8.55114 8.38845 8.55114 9.06702 8.96967 9.48556L13.9748 14.4907L12.9141 15.5513L7.90901 10.5462C6.90469 9.5419 6.90469 7.91357 7.90901 6.90925C8.91333 5.90493 10.5417 5.90493 11.546 6.90925L17.9223 13.2855C19.4495 14.8128 19.4495 17.289 17.9222 18.8163C16.395 20.3436 13.9187 20.3436 12.3915 18.8163L5.78769 12.2126C3.73744 10.1623 3.73744 6.83819 5.78769 4.78793Z"
      fill="currentColor" />
  </svg>
</template>
<style scoped>
svg {
  cursor: pointer;
  flex-shrink: 0;
  color: #A4A4A4;
}

svg:hover {
  color: #D8D8D8;
}
</style>
